// Force a fresh reload if this page is restored from the browser's
// back/forward cache (e.g. customer hits Back from checkout). Without this,
// some mobile browsers restore the OLD in-memory page/script state instead of
// re-running the current theme.js, which is why an already-removed behavior
// can seem to "come back" after going back from checkout.
window.addEventListener('pageshow', function (e) {
  if (e.persisted) {
    window.location.reload();
  }
});

document.addEventListener('DOMContentLoaded', function () {

  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var currentIndex = 0;

    function showIndex(i) {
      if (!thumbs.length) return;
      currentIndex = ((i % thumbs.length) + thumbs.length) % thumbs.length;
      var thumb = thumbs[currentIndex];
      var newSrc = thumb.getAttribute('data-full');
      if (mainImg && newSrc) { mainImg.src = newSrc; }
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (thumb.scrollIntoView) { thumb.scrollIntoView({ block: 'nearest' }); }
    }

    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () { showIndex(idx); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { showIndex(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showIndex(currentIndex + 1); });
  });

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantInput = form.querySelector('[data-variant-id-input]');
    var tiers = form.querySelectorAll('[data-tier]');

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        tiers.forEach(function (t) { t.classList.remove('is-selected'); });
        tier.classList.add('is-selected');

        if (variantInput) {
          variantInput.value = tier.getAttribute('data-variant-id');
        }

        var price = tier.getAttribute('data-price');
        var compare = tier.getAttribute('data-compare');
        var total = tier.getAttribute('data-total');

        var scopeRoot = form.closest('.pdp-info') || form.closest('.buy-grid') || document;
        scopeRoot.querySelectorAll('[data-price-display]').forEach(function (el) {
          var compareEl = el.querySelector('[data-compare-display]');
          el.childNodes[0].nodeValue = price + ' ';
          if (compareEl) {
            if (compare) { compareEl.textContent = compare; compareEl.style.display = ''; }
            else { compareEl.style.display = 'none'; }
          }
        });
        scopeRoot.querySelectorAll('[data-total-display]').forEach(function (el) {
          el.textContent = total;
        });
      });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var qtyInput = form.querySelector('[data-qty-input]');
    var qtyMinus = form.querySelector('[data-qty-minus]');
    var qtyPlus = form.querySelector('[data-qty-plus]');
    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = Math.max(1, v - 1);
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = v + 1;
      });
    }
  });

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var variantInput = form.querySelector('[data-variant-id-input]');
      var qtyInput = form.querySelector('[data-qty-input]');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var variantId = variantInput.value;

      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : null;
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Please wait...'; }

      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
          });
        })
        .then(function (res) { if (!res.ok) { throw new Error('add-to-cart-failed'); } return res.json(); })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
          alert('Something went wrong adding this to your cart. Please try again.');
        });
    });
  });

  document.querySelectorAll('[data-sticky-atc-button]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mainForm = document.querySelector('[data-product-form]');
      if (mainForm) {
        var submitBtn = mainForm.querySelector('[type="submit"]');
        if (submitBtn) { submitBtn.click(); }
      }
    });
  });
});
